interface MarketingCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

/**
 * Marketing card component with optional hover effects
 * Provides consistent styling across marketing pages
 *
 * @example
 * <MarketingCard hover>
 *   <h3>Feature Title</h3>
 *   <p>Feature description</p>
 * </MarketingCard>
 */
export function MarketingCard({
  children,
  className = '',
  hover = false
}: MarketingCardProps) {
  return (
    <div
      className={`
        rounded-lg border border-[#E6ECF2] bg-white shadow-[0_8px_30px_rgba(17,24,39,0.06)]
        ${hover ? 'transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_20px_40px_rgba(17,24,39,0.12)]' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
}
